import styled from "styled-components";

export const WrapperURL = styled.div`
  margin-left: 1px;
  .ant-input {
    width: ${({ width }) => width || "100%"};
    height: ${({ height }) => height || "44px"};
    border-color: ${({ border }) => border || "none"};
    color: #000;
    border-radius: 4px;
  }
  .ant-input:hover {
    box-shadow: none;
    border-color: #6610f2 !important;
  }
  .ant-input:focus,
  .ant-input-focused {
    /* box-shadow: 0 0 2px #6610f2; */
    box-shadow: none;
    border-color: #6610f2;
    outline: 0;
  }

  .ant-input-group-addon {
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    border: none;
    background: #e2e8f0;
    color: #9ea2ab;
    width: 12%;
    &:hover {
      box-shadow: 0 0 2px #6610f2;
      border-color: #6610f2;
    }
    &:focus {
      border: none;
    }
  }
`;
export const InputWrap = styled.div`
  border-radius: 4px;
  &:hover {
    box-shadow: 0 0 2px #6610f2;
    border-color: #6610f2;
    outline: 0px;
    border-radius: 4px;
  }

  .ant-input-group-addon:first-child:hover {
    border-color: #6610f2;
  }
`;
